<template>
  <div :class="`hc-3up-bucket__card bg-offwhite-100 js-scroll ${device === 'pc' ?'is-scrolled':''} is-scrolled-past`">
    <figure class="wp-block-image size-full">
      <img :src="imgUrl" alt="" />
    </figure>

    <h3 class="wp-block-heading has-t-disp-5-font-size">{{ title }}</h3>

    <p class="has-md-font-size desc">
      {{ desc }}
    </p>
    <CommonButton :clickHandle="() => { goPage() }" buttonType="tertiary" :buttonText="btnText" />
  </div>
</template>

<script setup>
import CommonButton from "@/components/CommonButton.vue";
import { inject } from "vue";
import { useRouter } from "vue-router";
const router = useRouter();
const device = inject("device");
const props = defineProps({
  imgUrl: {
    type: String,
    default: ''
  },
  title: {
    type: String,
    default: ''
  },
  desc: {
    type: String,
    default: ''
  },
  btnText: {
    type: String,
    default: ''
  },
  pathUrl: {
    type: String,
    default: ''
  },
  jobCategoryValue: {
    type: Number,
    default: null
  },

})

const goPage = () => {
  if(device.value === 'mb'){
    router.push({
      path: 'searchJobResult',
      query: {
        jobCategoryValue: props.jobCategoryValue
      }
    });
  }else {
    router.push({
      path: 'searchJob',
      query: {
        jobCategoryValue: props.jobCategoryValue
      }
    });
  }
};
</script>

<style lang="scss" scoped>
    ::v-deep(.wp-block-button) {
      width: 100%;
    }
    .desc{
      padding-top: 10px
    }
@media (max-width: 767px) {
  .anim .hc-3up-bucket__card {
    transform: none;
    opacity: 1;
    filter: none;
    transition-duration: 0.7s;
    gap: 0;
    .desc{
      padding: 0;
    }
    .wp-block-image{
      img{
        width: 40px;
        height: 40px;
      }
    }
    .wp-block-heading{
      font-size: 1.714rem;
      font-weight: 600;
    }
  }

}
</style>
